import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssociationPlaceDestinationService {

  private url = environment.api + "api/erp/association-place-destination";

  constructor(
    private http: HttpClient
  ) { }

  getAssociationsByPlace(placeId: any) {
    return this.http.get(this.url + `/place/${placeId}`);
  }

  getAssociationsByDestination(destinationId: number) {
    return this.http.get(this.url + `/destination/${destinationId}`);
  }

  createAssociation(placeId: number, destinationId: number) {
    return this.http.post(this.url + `/create?placeId=${placeId}&destinationId=${destinationId}`, {});
  }

  deleteAssociation(placeId: number, destinationId: number) {
    return this.http.delete(this.url + `/delete?placeId=${placeId}&destinationId=${destinationId}`);
  }
}
